module.exports = __webpack_public_path__ + "img/sensotex_xl.e1152ef.webp";